<template>
  <div>
    <div id="footer-wrapper">
      <div id="contact">
        <router-link :to="{ name: 'contact' }">Contact</router-link>
      </div>

      <div id="impressum">
        <router-link :to="{ name: 'impressum' }">Impressum</router-link>
      </div>

      <div id="datenschutz">
        <router-link :to="{ name: 'datenschutz' }">Datenschutz</router-link>
      </div>

      <!-- <div id="about">
        <router-link :to="{ name: 'about' }">About</router-link>
      </div> -->

      <!--
    <div style="display: flex; flex-direction: column; align-items: start; margin: 0 1rem;">
      <a href="mailto:patricia@patricia-sauer.com?subject=Feature%20Request">Have a <b>feature request</b>?</a>
      
      <a href="mailto:patricia@patricia-sauer.com?subject=Bug%20Report&amp;body=Hi%20Patricia,%0D%0A%0D%0Awhen%20I%20do%20...%20then%20...%20happens.%20You%20can%20reproduce%20this%20by%20following%20these%20steps:">Found a <b>bug</b>?</a>

      <a href="mailto:patricia@patricia-sauer.com">Wanna <b>get in touch</b>?</a>
    </div>

    <div style="margin: 0 1rem;">
      <a href="http://www.patricia-sauer.com">&copy; Patricia Sauer</a>
    </div>

    <div style="margin: 0 1rem;">
      <router-link
        :to="{ name: 'release-notes' }"
      >
        Version 1.0.0
      </router-link>
    </div>
    --></div>
  </div>
</template>

<style>
#footer {
position: fixed;
bottom: 0;
left: 0;
right: 0;

/*margin: 1rem 1rem;*/
/* display: flex;
display: -webkit-flex;
flex-direction: row; */
width: 100%;
z-index: 100;
background: linear-gradient(
      148deg,
      hsl(174, 72%, 76%) 0%,
      hsl(174, 72%, 36%) 100%
    )
    no-repeat;
}

#footer-wrapper {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  font-size: 0.75rem;
  margin-top: 0.5rem;
  /*
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  */
}

#contact {
  margin: 0 1rem 0.5rem 1rem;
}

#impressum {
  margin: 0 1rem 0.5rem 1rem;
}

#datenschutz {
  margin: 0 1rem 0.5rem 1rem;
}

#about {
  margin: 0 1rem 0.5rem 1rem;
}

a {
  color: hsl(210, 29%, 24%);
  text-decoration: none;
}

a:hover {
  color: hsl(210, 29%, 24%);
  text-decoration: underline;
}

a:active {
  color: hsl(210, 29%, 50%);
  text-decoration: underline;
}

@media (max-width: 675px) {
  #contact {
    grid-column: 1 / span 2;
  }

  #impressum {
    grid-column: 3 / span 2;
  }

  #datenschutz {
    grid-column: 5 / span 2;
  }

  #about {
    grid-column: 1 / span 2;
    margin-top: 0.5rem;
  }

}
</style>